import { nextTick } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px"
  }
};
import { ref, reactive, watch } from "vue";
import { message } from "ant-design-vue";
import { addResource, updateResource } from "@/api/menuMangeApi";
import { awaitWrap, OK } from "@/common";
// 接收props
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modalType: {
      default: "add"
    },
    menuData: {
      default: () => ({
        id: "",
        name: "",
        resType: 1,
        parentId: undefined,
        priority: 1,
        permission: undefined,
        // icon: '',
        url: ""
      })
    },
    parentMenuOptions: {
      default: () => []
    },
    subMenuOptions: null
  },
  emits: ["update:visible", "save", "cancel", "success"],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    // 定义需要发出的事件
    // 表单引用
    const formRef = ref();
    // 模态框类型（添加或编辑）
    const modalType = ref(props.modalType);
    // 确认加载状态
    const confirmLoading = ref(false);
    // 表单状态
    const formState = reactive({
      id: "",
      name: "",
      resType: 1,
      parentId: "",
      priority: 1,
      permission: undefined,
      // icon: '',
      url: ""
    });
    // 表单验证规则
    const rules = reactive({
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "blur"
      }],
      parentId: [{
        required: true,
        message: "请选择上级菜单",
        trigger: "change"
      }],
      url: [{
        required: true,
        message: "请输入页面路由",
        trigger: "blur"
      }],
      permission: [{
        validator: () => {
          if (formState.resType === 3 && (!formState.permissionProd || !formState.permission)) {
            return Promise.reject("权限标识和权限类型都不能为空");
          }
          return Promise.resolve();
        },
        trigger: ["blur", "change"],
        required: true
      }]
    });
    // 提交表单
    const handleModalOk = async () => {
      try {
        var _formRef$value, _formData$url;
        await ((_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate());
        // 创建一个新对象避免引用问题
        const formData = {
          id: formState.id,
          name: formState.name,
          resType: formState.resType,
          parentId: formState.parentId,
          priority: formState.priority,
          permission: formState.permission,
          // icon: formState.icon,
          url: formState.url,
          permissionProd: formState.permissionProd
        };
        // 根据类型处理特定字段
        if (formState.resType === 1) {
          // 一级菜单不需要parentId
          formData.parentId = "0";
          formData.permission = "";
        } else if (formState.resType === 2) {
          // 子菜单不需要icon
          // formData.icon = ''
          formData.permission = "";
        } else if (formState.resType === 3) {
          // 按钮不需要icon
          // formData.icon = ''
        }
        // 设置加载状态
        confirmLoading.value = true;
        const url = (_formData$url = formData.url) !== null && _formData$url !== void 0 && _formData$url.startsWith("/") ? formData.url : `/${formData.url}`;
        if (formState.resType === 3) {
          var _props$subMenuOptions;
          // 获取已选上级菜单
          const parentUrl = (_props$subMenuOptions = props.subMenuOptions.find(item => item.menuId === formData.parentId)) === null || _props$subMenuOptions === void 0 ? void 0 : _props$subMenuOptions.url;
          formData.permission = (parentUrl === null || parentUrl === void 0 ? void 0 : parentUrl.split("/")[1]) + ":" + formData.permissionProd + ":" + formData.permission;
        }
        // 根据modalType判断是新增还是编辑操作
        if (modalType.value === "add") {
          // 调用添加API
          const [err, res] = await awaitWrap(addResource({
            name: formData.name,
            resType: formData.resType,
            parentId: Number(formData.parentId),
            priority: formData.priority,
            permission: formData.permission || "",
            // icon: formData.icon,
            url,
            address: formData.resType === 3 ? "" : url === null || url === void 0 ? void 0 : url.split("/")[1]
          }));
          if (res && res.code === OK) {
            message.success("新增成功");
            emit("success");
            handleModalCancel();
            visible.value = false;
          }
          if (err) {
            message.error("新增失败");
          }
        } else {
          // 调用更新API
          const [err, res] = await awaitWrap(updateResource({
            id: formData.id,
            name: formData.name,
            resType: formData.resType,
            parentId: Number(formData.parentId),
            priority: formData.priority,
            permission: formData.permission || "",
            // icon: formData.icon,
            url,
            address: formData.resType === 3 ? "" : url === null || url === void 0 ? void 0 : url.split("/")[1]
          }));
          if (res && res.code === OK) {
            message.success("编辑成功");
            emit("success");
            handleModalCancel();
            visible.value = false;
          }
          if (err) {
            message.error("编辑失败");
          }
        }
      } catch (error) {
        console.error("表单验证失败", error);
      } finally {
        // 无论成功失败，都关闭加载状态
        confirmLoading.value = false;
      }
    };
    // 取消表单
    const handleModalCancel = () => {
      resetForm();
      emit("cancel");
    };
    // 重置表单
    const resetForm = () => {
      var _formRef$value2;
      formState.id = "";
      formState.name = "";
      formState.resType = 1;
      formState.parentId = undefined;
      formState.priority = 1;
      formState.permission = undefined;
      // formState.icon = ''
      formState.url = "";
      formState.permissionProd = "";
      (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 || _formRef$value2.resetFields();
    };
    // 清空表单
    const clearFormData = () => {
      var _formRef$value3;
      formState.id = "";
      formState.name = "";
      formState.resType = 1;
      formState.parentId = undefined;
      formState.priority = 1;
      formState.permission = undefined;
      formState.url = "";
      formState.permissionProd = "";
      // 表单重置后需要重设表单的验证状态
      (_formRef$value3 = formRef.value) === null || _formRef$value3 === void 0 || _formRef$value3.clearValidate();
    };
    // 监听resType变化，动态调整表单验证
    watch(() => formState.resType, newType => {
      var _formRef$value4;
      // 清除之前的验证状态
      (_formRef$value4 = formRef.value) === null || _formRef$value4 === void 0 || _formRef$value4.clearValidate();
      // 根据类型设置不同字段的验证
      if (newType === 1) {
        // 一级菜单不需要验证parentId
        rules.parentId = [];
      } else {
        // 子菜单和按钮需要验证parentId
        rules.parentId = [{
          required: true,
          message: "请选择上级菜单",
          trigger: "change"
        }];
      }
      // 按钮需要验证address和permission
      if (newType === 3) {
        rules.permission = [{
          validator: () => {
            if (formState.resType === 3 && (!formState.permissionProd || !formState.permission)) {
              return Promise.reject("权限标识和权限类型都不能为空");
            }
            return Promise.resolve();
          },
          trigger: ["blur", "change"],
          required: true
        }];
      } else {
        // 菜单和子菜单需要验证address，不需要验证permission
        rules.permission = [];
      }
    }, {
      immediate: true
    });
    // 可见性变量
    const visible = ref(props.visible);
    // 监听props变化
    watch(() => props.visible, newValue => {
      visible.value = newValue;
    });
    // 监听modalType变化
    watch(() => props.modalType, newValue => {
      modalType.value = newValue;
    });
    // 监听visible变化，向上传递更新
    watch(visible, newValue => {
      emit("update:visible", newValue);
    });
    // 监听菜单数据变化
    watch(() => props.menuData, newData => {
      nextTick(() => {
        if (props.modalType === "edit") {
          var _newData$permission, _formRef$value5;
          const permissionList = (_newData$permission = newData.permission) === null || _newData$permission === void 0 ? void 0 : _newData$permission.split(":");
          const permission = permissionList.length === 3 ? permissionList[2] : permissionList[1];
          const permissionProd = permissionList.length === 3 ? permissionList[1] : "";
          // 深度复制防止引用问题
          formState.id = newData.id || "";
          formState.name = newData.name || "";
          formState.resType = newData.resType || 1;
          formState.parentId = newData.parentId || undefined;
          formState.priority = newData.priority || 1;
          formState.permission = permission || undefined;
          formState.permissionProd = permissionProd || "";
          // formState.icon = newData.icon || ''
          formState.url = newData.url || "";
          // 表单重置后需要重设表单的验证状态
          (_formRef$value5 = formRef.value) === null || _formRef$value5 === void 0 || _formRef$value5.clearValidate();
        }
      });
    }, {
      deep: true,
      immediate: true
    });
    expose({
      clearFormData
    });
    return (_ctx, _cache) => {
      const _component_a_radio_button = _resolveComponent("a-radio-button");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[7] || (_cache[7] = $event => visible.value = $event),
        title: modalType.value === 'add' ? '新增菜单' : '编辑菜单',
        onOk: handleModalOk,
        onCancel: handleModalCancel,
        width: "600px",
        centered: "",
        "confirm-loading": confirmLoading.value,
        maskClosable: false,
        keyboard: true,
        role: "dialog",
        "aria-modal": "true"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formState,
          rules: rules,
          "label-col": {
            span: 6
          },
          "wrapper-col": {
            span: 16
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "菜单类型",
            name: "resType"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: formState.resType,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formState.resType = $event),
              "button-style": "solid",
              disabled: modalType.value === 'edit'
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio_button, {
                value: 1
              }, {
                default: _withCtx(() => [_createTextVNode("一级菜单")]),
                _: 1
              }), _createVNode(_component_a_radio_button, {
                value: 2
              }, {
                default: _withCtx(() => [_createTextVNode("子菜单")]),
                _: 1
              }), _createVNode(_component_a_radio_button, {
                value: 3
              }, {
                default: _withCtx(() => [_createTextVNode("按钮")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value", "disabled"])]),
            _: 1
          }), formState.resType !== 1 ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "上级菜单",
            name: "parentId"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: formState.parentId,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formState.parentId = $event),
              placeholder: "请选择上级菜单",
              "allow-clear": ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formState.resType === 3 ? __props.subMenuOptions : __props.parentMenuOptions, menu => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: menu.menuId,
                  value: menu.menuId
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(menu.name), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true), formState.resType !== 3 ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            label: "菜单名称",
            name: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formState.name,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formState.name = $event),
              placeholder: "请输入菜单名称"
            }, null, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true), formState.resType === 3 ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 2,
            label: "按钮名称",
            name: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formState.name,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formState.name = $event),
              placeholder: "请输入按钮名称"
            }, null, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: formState.resType === 3 ? '接口路径' : '页面路由',
            name: "url"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formState.url,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => formState.url = $event),
              placeholder: formState.resType === 3 ? '请输入接口路径' : '请输入页面路由'
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), formState.resType === 3 ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 3,
            label: "权限标识",
            name: "permission"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_input, {
              value: formState.permissionProd,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => formState.permissionProd = $event),
              placeholder: "请输入权限标识"
            }, null, 8, ["value"]), _createVNode(_component_a_select, {
              value: formState.permission,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => formState.permission = $event),
              placeholder: "请选择权限"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select_option, {
                value: "add"
              }, {
                default: _withCtx(() => [_createTextVNode("添加")]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: "del"
              }, {
                default: _withCtx(() => [_createTextVNode("删除")]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: "update"
              }, {
                default: _withCtx(() => [_createTextVNode("编辑")]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: "export"
              }, {
                default: _withCtx(() => [_createTextVNode("导出")]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: "import"
              }, {
                default: _withCtx(() => [_createTextVNode("导入")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "title", "confirm-loading"]);
    };
  }
});